<template>
  <div id="info-container" style="width: 25vw; min-width:350px;">
    <div>
      <p class="section-title">{{ $t('REMOTEACCESS') }}</p>
      <div>
        <div class="info-field horizontal">
          <tr class="info-field-row">
            <td style="width:200px;">
              <p class="info-field-title">{{ $t('Platform') }}</p>
            </td>
            <td style="width:200px;" class="info-field-value">
              <input v-model="remoteAccess.platform" type="text" :placeholder="$t('Platform')">
            </td>
          </tr>
        </div>
        <div class="info-field horizontal">
          <tr class="info-field-row">
            <td style="width:200px;">
              <p class="info-field-title">{{ $t('Description') }}</p>
            </td>
            <td style="width:200px;" class="info-field-value">
              <input v-model="remoteAccess.description" type="text" :placeholder="$t('Description')">
            </td>
          </tr>
        </div>
        <div class="info-field horizontal">
          <tr class="info-field-row">
            <td style="width:200px;">
              <p class="info-field-title">{{ $t('Login') }}</p>
            </td>
            <td style="width:200px;" class="info-field-value">
              <input v-model="remoteAccess.login" type="text" :placeholder="$t('Login')">
            </td>
          </tr>
        </div>
        <div class="info-field horizontal" v-if="isAdd">
          <tr class="info-field-row">
            <td style="width:200px;">
              <p class="info-field-title">{{ $t('Password') }}</p>
            </td>
            <td style="width:200px;" class="info-field-value">
              <input v-model="remoteAccess.password" type="password" :placeholder="$t('Password')">
            </td>
          </tr>
        </div>
        <div>
          <div class="error" v-if="error != ''">{{ error }}</div>
        </div>
      </div>
    </div>
    <div style="align-self: center;">
      <Button :title="$t('Save')" buttonClass='save-button semi-bold' style="width: 300px; align-self: center;"
        @onClick="save"></Button>
    </div>
  </div>
</template>

<script>
import { addRemoteAccess, editRemoteAccess } from '@/api/api'
import Button from '@/components/Button.vue';
import axios from "axios"

export default {
  props: {
    remoteAccessObject: {
      required: false,
      type: Object
    },
    systemId: {
      required: true,
      type: String
    }
  },
  components: {
    Button
  },
  provide: {
  },
  data() {
    return {
      remoteAccess: {
        platform: '',
        description: '',
        login: '',
        password: '',
        systemId: '',
        systemAccessId: ''
      },
      error: "",
      isAdd: false
    }
  },
  computed: {
  },
  methods: {
    async getData() {
      if (this.remoteAccessObject != null) {
        this.isAdd = false;
        this.remoteAccess.platform = this.remoteAccessObject.platform;
        this.remoteAccess.description = this.remoteAccessObject.description;
        this.remoteAccess.login = this.remoteAccessObject.login;
        this.remoteAccess.systemAccessId = this.remoteAccessObject.id;
      } else {
        this.isAdd = true;
        this.remoteAccess.systemId = this.systemId;

      }
    },

    async save() {
      if (this.remoteAccessObject == null) {
        this.error = ''
        await addRemoteAccess(this.remoteAccess)
          .then((d) => {
            this.$emit("save");
          }).catch((error) => {
            this.processError(error)
          })
      } else {
        this.error = ''
        await editRemoteAccess(this.remoteAccess)
          .then((d) => {
            this.$emit("save");
          }).catch((error) => {
            this.processError(error)
          })
      }
    },
    processError(error) {
      if (error.response.data != undefined) {
        this.error = error.response.data
      } else {
        // console.log({ err: error.response })
        this.error = ""
      }
    },

  },
  mounted: async function () {
    this.getData();
  }
}
</script>

<style scoped>
.error {
  text-align: left !important;
  color: #FD8282;
  font-size: 11px;
  font-weight: bold;
  font-family: 'Open Sans', sans-serif !important;
  font-style: normal !important;
  font-weight: 400 !important;
}

#info-container {
  padding: 20px;
  background: #FFFFFF;
  border: 1px solid #EFEFEF;
  box-sizing: border-box;
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1);
  border-radius: 5px 0px 0px 5px;
  justify-content: space-between;
  display: flex;
  flex-direction: column;
}

.info-field {
  border-bottom: 1px solid #E9E9E9;
  margin-bottom: 12px;
  margin-top: 12px;
}

.info-field-title {
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 16px;

  color: #272727;
  margin: 0;
}

.info-field-row {
  width: 100%;
  margin: 0;
  padding-bottom: 5px;
}

.info-field-value {
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 16px;

  color: #272727;
}

.section-title {
  font-weight: bold;
}

input[type=text],
input[type="email"],
input[type="password"] {
  border: none;
  width: 100%;
}

input[type=text]:focus,
input[type="email"]:focus,
input[type="password"]:focus {
  border-bottom: 1px solid #0095b2;
  outline: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Settings/General/RemoteAccessModal.vue